<template>
  <div class="ellipsis" :style="{'margin-left': align ? '-10px' : '0' }" v-if="tasks.length !== 0">
    <v-tooltip v-for="(task, i) in tasks" :key="`task-${i}`" bottom>
      <template v-slot:activator="{ on }">
        <v-chip class="mx-1" v-on="on" :dark="dark">
          {{ $store.getters['tasks/taskTypes']([task.task.task_type_id])[0].short_code }}
        </v-chip>
      </template>
      <template v-if="task.task.task_type_id === config.surveyTaskTypeId">
        {{ task.task.name }}
      </template>
      <template v-else-if="defaultConfig[i]">
        All Random
      </template>
      <template v-else>
        <div v-for="(value, key) in taskConfig[i]" :key="`${i}-${key}`">
          <template v-if="key !== 'default'">
            {{ key | startCase }}: {{ (value !== null ? value : 'random') }}
          </template>
        </div>
      </template>
    </v-tooltip>
  </div>
  <div v-else>
    <em>No tasks</em>
  </div>
</template>

<script>
import { config } from '@/helpers'

export default {
  name: 'TaskList',
  props: {
    /**
     *  The list of tasks to be displayed
     */
    tasks: {
      type: Array
    },
    /**
     *  If true, apply Vuetify's dark style on the chip
     */
    dark: {
      type: Boolean,
      default: false
    },
    /**
     *  If true, the chips will be slightly pulled left to align with text in other rows
     */
    align: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      config: config
    }
  },
  computed: {
    /**
     * taskConfig[i]: tasks[i]'s configurations to be displayed when hovering
     */
    taskConfig () {
      return this.tasks.map(task => task.task.config)
    },
    /**
     * defaultConfig[i]: true if tasks[i] has the default configuration
     */
    defaultConfig () {
      return this.tasks.map((task, i) => {
        return !task.task.config ||
          ('default' in this.taskConfig[i] && this.taskConfig[i].default) ||
          Object.values(this.taskConfig[i]).every(config => config === null)
      })
    }
  }
}
</script>
